import React from 'react'
import Select from 'react-select'
import SelectTimeSlotItemAddons from './SelectTimeSlotItemAddons'

import {
  formatDay,
  formatTime,
} from '../../../../_common/core/validation'

export const defaultValue = { value: 'all', label: 'All' }

const getDayAndHour = date => {
  const d = formatDay(date)
  const h = formatTime(date)
  return [d, h]
}

const getOptions = (timeSlots, defaultTicketIds) => {
  let selectedCounter = 0

  const options = [
    {
      value: 'All',
      label: 'All',
      options: timeSlots.map(el => ({ value: el.id })),
    },
  ]

  for (const el of timeSlots) {
    const [day, hour] = getDayAndHour(el.startDate)
    const optionIndex = options.findIndex(option => option.value === day)
    if (optionIndex !== -1) {
      options[optionIndex].options.push({ value: el.id, label: hour })
      if (defaultTicketIds.includes(el.id)) {
        selectedCounter++
        options[optionIndex].selectedTickets.push(el.id)
      }
    } else {
      const isSelected = defaultTicketIds.includes(el.id)
      if (isSelected) {
        selectedCounter++
      }
      options.push({
        value: day,
        label: day,
        options: [{ value: el.id, label: hour }],
        selectedTickets: isSelected ? [el.id] : [],
      })
    }
  }

  const allSelected = selectedCounter === timeSlots.length
  const noSelectedDays = []
  const selectedDays = []

  for (const el of options) {
    if (el?.selectedTickets?.length) {
      selectedDays.push(el)
    } else {
      noSelectedDays.push(el)
    }
  }

  return { allSelected, selectedDays, noSelectedDays }
}

const SelectTimeSlotAddons = props => {
  const { timeSlots, defaultTicketIds } = props
  const { allSelected, selectedDays, noSelectedDays } = getOptions(timeSlots, defaultTicketIds)


  const addDay = e => {
    const ids = [...e.options.map(ticket => ticket.value), ...defaultTicketIds]
    props.onChange(ids)
  }

  const onDeleteDay = e => {
    const ids = []
    const newSelectedDays = selectedDays.filter(el => el.value !== e.value)
    for (const selectedDay of newSelectedDays) {
      ids.push(...selectedDay.selectedTickets)
    }
    props.onChange(ids)
  }

  const onChangeDay = (newDay, prevDay) => {
    const ids = newDay.options.map(ticket => ticket.value)
    if (newDay.value === 'All' || prevDay.value === 'All') {
      props.onChange(ids)
    } else {
      const newSelectedDays = selectedDays.filter(el => el.value !== prevDay.value)
      for (const selectedDay of newSelectedDays) {
        ids.push(...selectedDay.selectedTickets)
      }
      props.onChange(ids)
    }
  }

  const onChangeTime = (e, d) => {
    const ids = [...e.map(el => el.value)]
    for (const selectedDay of selectedDays) {
      if (selectedDay.value !== d.value) {
        ids.push(...selectedDay.selectedTickets)
      }
    }
    props.onChange(ids)
  }

  return (
    <div style={{ width: 'max-content' }}>
      {allSelected ? (
        <SelectTimeSlotItemAddons
          day={
            {
              value: 'All',
              label: 'All',
              options: timeSlots.map(el => ({ value: el.id })),
            }
          }
          noSelectedDays={selectedDays}
          hours={[]}
          onChangeDay={onChangeDay}
          onChangeTime={onChangeTime}
          onDelete={onDeleteDay}
          defaultValue={[]}
        />
      ) : selectedDays.map(el => (
        <SelectTimeSlotItemAddons
          key={el.value}
          day={el}
          noSelectedDays={noSelectedDays}
          onChangeDay={onChangeDay}
          onChangeTime={onChangeTime}
          onDelete={onDeleteDay}
        />
      ))}
      {!allSelected ? (
        <div>
          <div style={{ display: 'inline-block', width: 300, margin: '5px 10px 5px 20px' }}>
            <Select menuIsOpen onChange={addDay} value={null} options={noSelectedDays} />
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default SelectTimeSlotAddons
